import React, {useCallback} from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import defaultStyles from './styles';
import {DataTableContext} from '../Utils/DataTableContext';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const Head = props => {

  const {setController, controller} = React.useContext(DataTableContext);
  const [formState, setFormState] = React.useState('');
  const [formFocus, setFormFocus] = React.useState(false);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const container = React.useRef();
  let styles = {...defaultStyles};
  const [customCompWidth, setCustomCompWidth] = React.useState('auto');
  styles.contentRight.width = customCompWidth !== 'auto' ? customCompWidth + 'px' : customCompWidth;

  // activity log
  const handleActivityLogUpdate = (_id) => trackActivity({body: {
      _id,
      instance: contextInstance || user.instance,
      user: user.id
    }
  })

  // set custom component width for measurements
  const handleMeasure = useCallback(node => {
    if (container.current && node && customCompWidth !== node.clientWidth)
    setCustomCompWidth(container.current.clientWidth - node.clientWidth);
  })

  // clear search input
  const clearSearch = () => {
    setFormState('');
    controller.reset();
    handleActivityLogUpdate(`Head.clearSearch`)
  }


  return(
    <div style={styles.container} ref={container}>
      <div style={styles.contentWrap}>
        <div style={{...styles.content, ...styles.contentLeft}}>
          <form
            onSubmit={e => e.preventDefault()}
            style={styles.form}
          >
            <input
              type='text'
              value={formState}
              onChange={e => {
                setFormState(e.target.value);
                controller.globalQueryData(e.target.value.toLowerCase())
              }}
              style={styles.searchInput}
              placeholder='Search...'
            />
            {formState !== '' &&
              <Button
                onClick={clearSearch}
                styles={styles.clearBtn}
                hoverStyles={styles.clearBtnHov}
              >
                <svg style={styles.clearIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"/></svg>
              </Button>
            }
          </form>
        </div>
        <div style={{...styles.content, ...styles.contentRight}} ref={handleMeasure}>
          {props.customComponents && props.customComponents.headLeft &&
            <props.customComponents.headLeft.component
              {...props.customComponents.headLeft.props}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default Head;
